export default function getAllTeacherNames(uploadData) {
  const teacherKeys = ['englishteacher', 'mathteacher', 'homeroomteacher', 'scienceteacher']
  const teacherNames = {}
  uploadData.forEach(record => {
    teacherKeys.forEach(key => {
      const name = record[key]
      if (name && teacherNames[name]) {
      teacherNames[name].push(record.row)
      } else {
      teacherNames[name] = [record.row]
      }
    })
  })
  let teacherNamesOnly = Object.keys(teacherNames)
  return { teacherNamesOnly, teacherNames }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/getAllTeacherNames.js